export default __webpack_public_path__ + "static/media/Notifications.bf804ff0.svg";